<div class="container">
  <div class="error-section">
    <img src="assets/images/pagenotfound/errorImage.png" alt="404 Error Image" class="error-image" />

    <p>Page Not Found</p>
    <p>The page you're looking for might have been removed.</p>
    <a href="/" class="home-button">Go to home page</a>
  </div>
</div>